export default "__VITE_ASSET__DaPKq8kQ__"